import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { BraulioWidgetService } from '@core/services/braulio-widget/braulio-widget.service';

@Component({
  selector: 'ln-app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  title = 'Luna Nueva Portal';
  private braulioWidget = inject(BraulioWidgetService);

  ngOnInit(): void {
    this.braulioWidget.loadWidget();
  }
}
